import { CreateDisbursementFormFields } from "../Hooks/useCreateDisbursementForm";
import { RegisterOptions } from "react-hook-form/dist/types";
import { useFormContext } from "react-hook-form";

const routingNumberLengthError = {
  value: 9,
  message: "Routing number must be 9 digits.",
};
const accountNumberMaxLengthError = {
  value: 17,
  message: "Account number must be 17 or fewer digits.",
};
const accountNumberMinLengthError = {
  value: 4,
  message: "Account number must be 4 or more digits.",
};

type EnterBankAccountFormField = {
  label: string;
  name: keyof CreateDisbursementFormFields;
  placeholder?: string;
  registerValue: Partial<RegisterOptions>;
};

const useEnterBankAccountFormFields: () => EnterBankAccountFormField[] = () => {
  const { getValues } = useFormContext<CreateDisbursementFormFields>();
  return [
    {
      label: "Routing Number",
      name: "routingNumber",
      placeholder: "e.g. 021000089",
      registerValue: {
        maxLength: routingNumberLengthError,
        minLength: routingNumberLengthError,
      },
    },
    {
      label: "Account Number",
      name: "accountNumber",
      placeholder: "e.g. 68379019",
      registerValue: {
        maxLength: accountNumberMaxLengthError,
        minLength: accountNumberMinLengthError,
      },
    },
    {
      label: "Confirm Account Number",
      name: "confirmAccountNumber",
      registerValue: {
        maxLength: accountNumberMaxLengthError,
        minLength: accountNumberMinLengthError,
        validate: (value: string) =>
          value === getValues().accountNumber ||
          "Please confirm account number",
      },
    },
  ];
};

export default useEnterBankAccountFormFields;
